import React, { type JSX } from 'react';
import { useGetLoadGroupByIdQuery } from '@fiji/common/src/features/loadGroups/loadGroupsApi';
import { AddMultiDeviceLoads } from './AddMultiDeviceLoads';
import { AddSingleDeviceLoads } from './AddSingleDeviceLoads';
import { useLocation } from 'react-router-dom';

export type SelectedLoad = {
    id: string;
    loadId?: string;
    loadName?: string;
    name?: string;
    loadNumber?: number | string;
    deviceId?: string;
    deviceName?: string;
    groupPath?: string[] | string;
};

type Props = {
    selectedLoadIds: SelectedLoad[];
    onToggleMultiLoad: (loadId: string, load?: SelectedLoad) => void;
    setSelectedAddLoads: (loads: SelectedLoad[]) => void;
    loadGroupId?: string;
    existingLoadIds?: string[];
};

export const AddLoads = ({
    selectedLoadIds,
    onToggleMultiLoad,
    loadGroupId,
    setSelectedAddLoads,
    existingLoadIds = [],
}: Props): JSX.Element => {
    const { data: loadGroupData } = useGetLoadGroupByIdQuery({ loadGroupId }, { skip: !loadGroupId });
    const { state } = useLocation();
    const isMultipleDevice = Boolean(
        loadGroupData?.data?.loadGroup?.isMultipleDevice || state?.createPayload?.isMultipleDevice
    );
    const selectedDeviceId = loadGroupData?.data?.loadGroup?.deviceIds?.[0] ?? '';
    const loadGroupModelCategory =
        loadGroupData?.data?.loadGroup?.modelCategory ?? state?.createPayload?.modelCategory ?? '';

    if (isMultipleDevice) {
        return (
            <AddMultiDeviceLoads
                selectedLoadIds={selectedLoadIds}
                onToggleLoad={onToggleMultiLoad}
                allowedModelCategory={loadGroupModelCategory}
                existingLoadIds={existingLoadIds}
            />
        );
    }

    return (
        <AddSingleDeviceLoads
            selectedLoadIds={selectedLoadIds}
            selectedDeviceId={selectedDeviceId}
            setSelectedAddLoads={setSelectedAddLoads}
            existingLoadIds={existingLoadIds}
        />
    );
};
